module.exports = __webpack_public_path__ + "assets/img/qualification-authority.3c9ba4a2.jpg";